// Opened from a dropdown option: the popup is gone after closing, so return to the button that controls it
const triggerOf = (el: HTMLElement | null) => {
  const popup = el?.closest<HTMLElement>('[role="listbox"], [role="menu"]');
  if (!popup?.id) return el;
  return (
    document.querySelector<HTMLElement>(
      `[aria-controls="${CSS.escape(popup.id)}"]`,
    ) ?? el
  );
};

/**
 * headlessui's Dialog makes the rest of the page inert while it is open, which blurs the element that opened it,
 * so focus ends up on <body> after closing. Remember the opener and focus it again.
 * Call the returned function once the dialog has left; unmounting restores as well.
 */
export const useRestoreFocus = (isOpen: () => boolean) => {
  let opener: HTMLElement | null = null;

  // The dialog's focus trap is still mounted when its transition ends and would pull focus back, so wait for it to go
  const restore = () =>
    setTimeout(() => {
      opener?.focus();
      opener = null;
    });

  watch(
    isOpen,
    (open) => {
      if (open)
        opener = triggerOf(document.activeElement as HTMLElement | null);
    },
    { immediate: true },
  );
  onUnmounted(restore);

  return restore;
};
